/**
 * @module ps4/playerManager
 * @private
 */

const playerErrorCodes = {
  LOAD_ERROR: "571141",
  PLAYER_ERROR: "571142",
  PLAYER_STREAMING_ERROR: "571143",
  CONTENT_AVAILABLE: "571144",
  SCE_AVPLAYER_ERROR: "571145"
};

export const commandErrors = {
  playerError: playerErrorCodes.PLAYER_ERROR,
  playerStreamingError: playerErrorCodes.PLAYER_STREAMING_ERROR,
  contentAvailable: playerErrorCodes.CONTENT_AVAILABLE,
  load: playerErrorCodes.LOAD_ERROR,
  playerMessage: playerErrorCodes.SCE_AVPLAYER_ERROR
};
